import { Hub } from 'aws-amplify/utils';
import { validateSession } from './authService';
import { signOut, fetchAuthSession } from 'aws-amplify/auth';

const makeInStoreHeaders = async () => {
  const isValid = await validateSession();
  if (isValid){
    const token = await localStorage.getItem('token');
    return {
      Authorization: token,
      'Content-Type': 'application/json'
    };
  } 
  Hub.dispatch('storeAuth', {event: 'expired'})
}

const makeCognitoHeaders = async () => {
  try {//check user is still valid and refresh token if yes
    const accessToken = (await fetchAuthSession({ forceRefresh: true })).tokens?.accessToken
    return {
      Authorization: accessToken,
      'Content-Type': 'application/json'
    };
  } catch(error){
    console.log(error)
    signOut();
  }
}

const makeHeaders = async() => {
  const isInStore = await localStorage.getItem('isInStore');
  const headers = await isInStore? makeInStoreHeaders(): makeCognitoHeaders();
  return headers
};

export default makeHeaders;